export const pixels = 6